import React, { FC } from 'react'
import Head2 from '../../components/heads/head2'
import { Link } from 'react-router-dom'
import CommonTemplate from '../../components/templates/common_template'
import { useSpBreakPoint } from '../../hooks/use_sp_breakpoint'

const SendRegisterEnterpriseEmailPage: FC = () => {
  const isSp = useSpBreakPoint()

  const content = (
    <CommonTemplate isSp={isSp}>
      <div className="flex justify-center">
        <div>
          <div className="mb-8">
            <Head2 title="会員登録 メール送信完了" />
          </div>
          <div className="max-w-[640px] bg-white rounded-xl md:px-6 px-4 py-12">
            <div className="pb-4">
              <p>
                このたびは、会員登録をして頂き誠にありがとうございます。
                <br />
                ご記入いただいたメールアドレスへ、メールアドレス認証のための確認メールをお送りしております。
                <br />
                メール本文記載のURLからアクセスし、会員登録を完了させてください。
              </p>
            </div>
            <div className="flex justify-center">
              <div className="w-fit px-4 py-2 bg-main-blue rounded-lg text-white">
                <Link to="/">TOPページへ戻る</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonTemplate>
  )

  return <div>{content}</div>
}

export default SendRegisterEnterpriseEmailPage
